module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "community-detail"
  }, [_c('swiper', {
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.communityPic), function(img) {
    return _c('swiper-slide', {
      key: img,
      staticClass: "swiper-item"
    }, [_c('img', {
      attrs: {
        "src": img
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination ",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "detail-list"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_c('img', {
    staticClass: "community-logo",
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "community-name"
  }, [_vm._v(_vm._s(_vm.communityName))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', {
    staticClass: "detail-item-value"
  }, [_vm._v(_vm._s(_vm.tel))]), _vm._v(" "), (_vm.tel) ? _c('a', {
    staticClass: "detail-btn",
    attrs: {
      "href": 'tel:' + _vm.tel
    }
  }, [_vm._v("咨询"), _c('img', {
    attrs: {
      "src": require("../assets/image/consult_icon_black@2x.png"),
      "height": "32",
      "width": "32",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', {
    staticClass: "detail-item-value"
  }, [_vm._v(_vm._s(_vm.address))]), _vm._v(" "), (_vm.address) ? _c('span', {
    staticClass: "detail-btn"
  }, [_vm._v("导航"), _c('img', {
    attrs: {
      "src": require("../assets/image/navigation_icon_black@2x.png"),
      "alt": ""
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "community-detail-article"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c856d318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communityDetail.vue
// module id = 240
// module chunks = 1